// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"987533c4","207":"a4d87e8e","488":"bf14b5b7","544":"9b82527b","618":"46d76e84"}[chunkId] + ".chunk.js";
};